import classNames from 'classnames';

import { OBJECT_TYPE_COLLECTIONS } from '@iconik-io/iconik-api/src/types/object_types';
import { Heading, type HeadingProps, Icon, Stack } from '@iconik-io/uad';

import styles from './card_item_without_keyframes_thumbnail.module.css';

type CardSize = 's' | 'm';

const sizeToHeadingLevel: Record<CardSize, HeadingProps['level']> = {
  m: 3,
  s: 5,
};

type CardItemWithoutKeyframesThumbnailProps = {
  objectType?: string;
  className?: string;
  mediaType?: string;
  cardSize: CardSize;
};

export function CardItemWithoutKeyframesThumbnail({
  cardSize,
  className,
  mediaType,
  objectType,
}: CardItemWithoutKeyframesThumbnailProps) {
  const classes = classNames(styles.not_available, className);

  if (objectType === OBJECT_TYPE_COLLECTIONS) {
    return (
      <Stack className={classes} alignItems="center" justifyContent="center">
        <Icon name="collection" size="xl" />
      </Stack>
    );
  }

  if (mediaType === 'Unknown') {
    return (
      <Stack className={classes} alignItems="center" justifyContent="center">
        <Icon name="asset_type_unknown" size={cardSize === 'm' ? 'xl' : 'm'} />
      </Stack>
    );
  }

  return (
    <Stack className={classes} alignItems="center" justifyContent="center">
      <div className={styles.wrapper}>
        <Heading
          className={styles.heading}
          level={sizeToHeadingLevel[cardSize]}
        >
          {mediaType}
        </Heading>
      </div>
    </Stack>
  );
}
